import StatsCard from './StatsCard.vue'
import DeploymentScenarioCard from './DeploymentScenarioCard.vue'
import DeploymentScenarioDetails from './DeploymentScenarioDetails.vue'
import StrategyCard from './StrategyCard.vue'
import ResultsCard from './ResultsCard.vue'
import ErrorLogDisplay from './ErrorLogDisplay.vue'
import MissionComputation from './MissionComputation.vue'
import PlotItem from './PlotItem.vue'
import ConstellationOptimizerTable from './ConstellationOptimizerTable.vue'

const dashboardComponents = {
  install(Vue) {
    Vue.component(PlotItem.name, PlotItem)
    Vue.component(StatsCard.name, StatsCard)
    Vue.component(DeploymentScenarioCard.name, DeploymentScenarioCard)
    Vue.component(DeploymentScenarioDetails.name, DeploymentScenarioDetails)
    Vue.component(StrategyCard.name, StrategyCard)
    Vue.component(ResultsCard.name, ResultsCard)
    Vue.component(ErrorLogDisplay.name, ErrorLogDisplay)
    Vue.component(MissionComputation.name, MissionComputation)
    Vue.component(ConstellationOptimizerTable.name, ConstellationOptimizerTable)
  }
}

export default dashboardComponents
